import { useEffect, useState } from "react";
import { api } from "../../api";

export default function Standards({ dark, chemName, onRequestQuote }) {
  const [standards, setStandards] = useState([]);
  const [certs, setCerts] = useState([]);

  useEffect(() => {
    api.getStandards().then((d) => {
      setStandards(d.standards);
      setCerts(d.certifications);
    });
  }, []);

  return (
    <section className={"panel" + (dark ? " dark" : "")} id="standards" data-testid="section-standards">
      <div className="wrap">
        <div className="panel-head">
          <div className="eyebrow">Compliance · regulatory hub</div>
          <h2>BIS / IS / FSSAI standards</h2>
          <p>
            Plain-language index of the specification each grade is manufactured and tested against.
            Always confirm the current revision directly with BIS before citing in a contract.
          </p>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table className="std" data-testid="standards-table">
            <thead>
              <tr>
                <th>Substance</th>
                <th>Indian Standard</th>
                <th>Covers</th>
                <th>Other applicable regime</th>
              </tr>
            </thead>
            <tbody>
              {standards.map((s, i) => (
                <tr key={i}>
                  <td>{s.substance}</td>
                  <td className="mono">{s.standard}</td>
                  <td>{s.covers}</td>
                  <td>{s.other}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="cert-strip" data-testid="cert-strip">
          {certs.map((c, i) => (
            <div className="cert" key={i}>
              <span className="dot" />
              {c}
            </div>
          ))}
        </div>
        <button
          className="btn btn-brand btn-sm"
          style={{ marginTop: 20 }}
          onClick={() => onRequestQuote?.("standards")}
          data-testid="standards-request-quote"
        >
          Get pricing for {chemName || "a compliant grade"}
        </button>
      </div>
    </section>
  );
}
